module.exports = __webpack_public_path__ + "static/img/hot.d1734a2c.svg";